export default "__VITE_ASSET__637e3b64__"